<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardVideo
            :cardContent="content"
            :pathVideoIpad="videoSplit"
            :checkWidth="CheckWidth"
            @nextRoute="nextRoute"
            @returnData="returnData"
          />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardVideo from './components/CardVideo.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardVideo, LoadingMDL},
  name: 'CTV01',
  data() {
    return {
      content: {},
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      videoSplit: '',
      CheckWidth: window.innerWidth,
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      nextRoutePath: [],
      conditionRoute: 'next',
      navigate: {},
      v3Data: {},
      nextPath: null,
    };
  },

  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getCheckAnswerResult: 'template/getCheckAnswerResult',
      getTemplatev3: 'v3/getTemplates',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
  },

  watch: {
    getTemplatev3: {
      handler(val) {
        if (!val) return;

        this.v3Data = val;

        this.content = val.templates[0];
        this.navigate = val.templates[0].navigate;

        if (this.conditionRoute != 'next') {
          window.location.reload();
        }

        if (!this.content.enable) {
          const pathFormat = this.content.navigate.close.action.split('-');
          alert('Access denied!');
          this.$router.push(`/v4/${pathFormat[0]}/${pathFormat[1]}`);
        }
        this.videoSplit = val.templates[0].content.item[0].image;

        this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

        this.loading = false;
      },
    },
    saveContentStatusv4: function (val) {
      // console.log(val, 'CTV01 Watcher Call');
      if (this.nextPath) {
        this.loading = true;
        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        // //to LTK 01
        this.$router.push(onNext);
      }
    },
    storeLanguage: function (val) {
      this.lang = val;
    },

    '$route.params.id'() {
      this.onLoad();
    },
  },

  mounted() {
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.loading = true;

      this.courseCode = this.$store.state.necessary.learningCourse;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();
      this.conditionRoute = 'next';

      const contentId = `CTV01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },

    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },

    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(val) {
      this.conditionRoute = 'go';
      let str = val.split('-');
      this.nextRoutePath = str;
      this.funcRoute();
    },
    returnData(val) {
      this.conditionRoute = 'returnData';
      let str = val.split('-');
      this.nextRoutePath = str;
      this.funcRoute();
    },
    funcRoute() {
      const nextAction = this.navigate.next.action;

      this.commitPayloadData(nextAction);
    },
    commitPayloadData(path) {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          console.log('current Code = lastCode save content and clear stack');

          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });
          this.nextPath = path;
        } else {
          //onNext
          const str = path.split('-');
          const nextPath = `/v4/${str[0]}/${str[1]}`;
          this.$router.push(nextPath);
        }
        //if not just clear stack
      }
    },
  },
};
</script>
<style></style>
